import request from '@/utils/request'

// 解绑
export function sort(data = {}) {
  return request({
    url: '/workWechat/kfMsgV2/updateMsgSort',
    method: 'post',
    data
  })
}
